module.exports = __webpack_public_path__ + "static/media/bolso (32).5156a666.jpg";